import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import Loader from '../Loader/Loader'
function CurrentUpcommingPlans() {
    const [currentPlan, setCurrentPlan] = useState(true)
    const [upcommingPlan, setUpcommingPlan] = useState(false)
    const [currentplandData, setCurrentPlanData] = useState([])
    const [upcommingPlanData, setUpcommingPlanData] = useState([])
    const [isSubCancelled, setIsSubcscriptionCancellled] = useState(false)
    const [loading, setLoading] = useState(true);
    const handlecurrentPlan = () => {
        console.log('current plan button clicked');
        setCurrentPlan(true)
        setUpcommingPlan(false)
    }
    useEffect(() => {
        const width = window.innerWidth
        currentUpcommingPlans();
        /*  if(width > 768)
         {
             setCurrentPlan(true)
             setUpcommingPlan(true)
         } */
        // alert(width)
    }, [])
    const handleupcommingPlan = () => {
        console.log('upcomming plan button clicked');
        setCurrentPlan(false)
        setUpcommingPlan(true)
    }
    const currentUpcommingPlans = async () => {
        try {
            setLoading(true)
            const data = JSON.stringify({
                'user_id': localStorage.getItem('dastaan__user_id') != null ? localStorage.getItem('dastaan__user_id') : 0
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/current-upcoming-plans`,
                headers: {
                    'Authorization': localStorage.getItem('dastaan__token'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios.request(config).then((response) => {
                console.log(response.data.data);
                setCurrentPlanData(response.data?.data?.current_plan)
                setUpcommingPlanData(response.data?.data?.upcoming_plans)
                setIsSubcscriptionCancellled(response.data?.data?.payment_made?.is_subscription_cancelled === 0 ? false : true)
                localStorage.setItem('is_subscription_cancelled', response.data?.data?.plan_status?.is_subscription_cancelled === 0 ? false : true)
                setLoading(false)
            })
        } catch (error) {
            setLoading(false)
        }
    }
    return (
        <div className='current-upcomming-plan mt-3'>
            <Row className='cu-tab'>
                <Col md={6} xl={6} sm={6} xs={6} onClick={handlecurrentPlan}>
                    <span className={`cu-text  ${currentPlan && 'cu-text-active'}`}>Current Plan</span>
                </Col>
                <Col md={6} xl={6} sm={6} xs={6} onClick={handleupcommingPlan}>
                    <span className={`cu-text  ${upcommingPlan && 'cu-text-active'}`}>Upcomming Plan</span>
                </Col>
            </Row>
            {/* current plan */}
            <Row>
                {loading ?
                    (
                        <Loader loading={loading} />) :
                    (
                        <>
                            <Col md={12} xl={12} sm={12} xs={12} className={`main-card cu-tab-seaction current-plan ${currentPlan ? 'show' : 'hide'}`}>
                                {
                                    currentplandData == null ? (<h5 className='p-1 text-center'>Plan not purchased</h5>) : (<>
                                        <Row className='main-row'>
                                            <Col md={6} xs={4}><span className='c-u-text'>Plan</span></Col>
                                            <Col md={6} xs={8} className='value-row'><span className='c-u-value'>{currentplandData.plan_name}</span></Col>
                                        </Row>
                                        <Row className='main-row'>
                                            <hr />
                                        </Row>
                                        <Row className='main-row'>
                                            <Col md={6} xs={4}><span className='c-u-text'>Amount</span></Col>
                                            <Col md={6} xs={8} className='value-row'><span className='c-u-value'>{currentplandData.plan_price - currentplandData.discount}</span></Col>
                                        </Row>
                                        <Row className='main-row'>
                                            <hr />
                                        </Row>
                                        <Row className='main-row'>
                                            <Col md={6} xs={6}><span className='c-u-text'>Date of Transaction</span></Col>
                                            <Col md={6} xs={6} className='value-row'><span className='c-u-value'>{currentplandData.created_at}</span></Col>
                                        </Row>
                                        <Row className='main-row'>
                                            <hr />
                                        </Row>
                                        <Row className='main-row'>
                                            <Col md={6} xs={4}><span className='c-u-text'>Validity</span></Col>
                                            <Col md={6} xs={8} className='value-row'><span className='c-u-value'>{currentplandData.from_date} to {currentplandData.to_date}</span></Col>
                                        </Row>
                                        <Row className='main-row'>
                                            <hr />
                                        </Row>
                                        <Row className='main-row'>
                                            <Col md={6} xs={4}><span className='c-u-text'>Status</span></Col>
                                            <Col md={6} xs={8} className='value-row'><span className={`c-u-value ${currentplandData.is_subscription_cancelled ? 'cancelled-txt' : 'active-txt'}`}>{currentplandData.is_subscription_cancelled ? 'Cancelled' : 'Active'}</span></Col>
                                        </Row>
                                    </>)
                                }
                            </Col>
                        </>
                    )
                }
                {/* upcomming plans */}
                <Col md={12} xl={12} sm={12} xs={12} className={`main-card cu-tab-seaction upcomming-plan ${upcommingPlan ? 'show' : 'hide'}`} >
                    {
                        upcommingPlanData.length == 0 ? (
                            <h5 className='p-1 text-center'>No upcomming plans</h5>
                        ) : (
                            upcommingPlanData.map((item) => {
                                return (
                                    <>
                                        <Row className='main-row'>
                                            <Col md={6} xs={4}><span className='c-u-text'>Plan</span></Col>
                                            <Col md={6} xs={8} className='value-row'><span className='c-u-value'>{item.plan_name}</span></Col>
                                        </Row>
                                        <Row className='main-row'>
                                            <hr />
                                        </Row>
                                        <Row className='main-row'>
                                            <Col md={6} xs={4}><span className='c-u-text'>Amount</span></Col>
                                            <Col md={6} xs={8} className='value-row'><span className='c-u-value'>{item.plan_price - item.discount}</span></Col>
                                        </Row>
                                        <Row className='main-row'>
                                            <hr />
                                        </Row>
                                        <Row className='main-row'>
                                            <Col md={6} xs={6}><span className='c-u-text'>Date of Transaction</span></Col>
                                            <Col md={6} xs={6} className='value-row'><span className='c-u-value'>{item.created_at}</span></Col>
                                        </Row>
                                        <Row className='main-row'>
                                            <hr />
                                        </Row>
                                        <Row className='main-row'>
                                            <Col md={6} xs={4}><span className='c-u-text'>Validity</span></Col>
                                            <Col md={6} xs={8} className='value-row'><span className='c-u-value'>{item.from_date} to {item.to_date}</span></Col>
                                        </Row>
                                        <Row className='main-row'>
                                            <hr />
                                        </Row>
                                        <Row className='main-row'>
                                            <Col md={6} xs={4}><span className='c-u-text'>Status</span></Col>
                                            <Col md={6} xs={8} className='value-row'><span className={`c-u-value ${item.is_subscription_cancelled == 1 ? 'cancelled-txt' : 'active-txt'}`}>{item.is_subscription_cancelled == 1 ? 'Cancelled' : 'Active'}</span></Col>
                                        </Row>
                                    </>
                                )
                            })
                        )
                    }
                </Col>
            </Row>
        </div>
    )
}
export default CurrentUpcommingPlans